import React from "react";
import YouTube from "react-youtube";

let _isMounted = false;

class YoutubeVideo extends React.Component {
  componentWillUnmount() {
    _isMounted = false;
  }

  componentDidMount() {
    _isMounted = true;
  }
  render() {
    return (
      <YouTube
        videoId={this.props.videoId}
        opts={{}}
        onReady={() => this.props.onReady()}
        onPlay={() => this.props.onPlay()}
      />
    );
  }
}

export default YoutubeVideo;
